import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import cn from "classnames";
import { FormattedMessage, FormattedHTMLMessage, useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";

import { isMobile } from "../../../../common/parameters";

import { IStateTree } from "../../../store/interfaces";
import Icon from "../../../icon";
import routing from "../../../routing";
import { amazonHost } from "../../../paths";

import Button from "../../../components/BigWhiteButton";
import RecentPlans from "../../../components/RecentPlans";

import {
    StyledHero,
    Background,
    HeroContent,
    ButtonWrapper,
    LaunchContainer,
    ToMemory,
    MorePlans,
    YearIcon,
    Progress,
    ProgressTitle,
    Percent,
    ToChoir,
} from "./styles";

import messages from "./messages";
import { IDonationData, IProps } from "./interfaces";
import { get } from "../../../actions/general";
import DonationPopup from "./DonationPopup";

const dev = process.env.NODE_ENV === "development";

const Hero = ({ scrollToTaskTypes }: IProps) => {
    const dispatch = useDispatch();
    const { locale } = useIntl();
    const [scrollTop, setScrollTop] = useState(0);
    const { user, webp } = useSelector((state: IStateTree) => state);
    const [donationData, setDonationData] = useState<IDonationData | undefined>();
    const [donationOpen, setDonationOpen] = useState(false);

    const handleCloseDonation = () => setDonationOpen(false);
    const handleOpenDonation = () => setDonationOpen(true);

    const handleScroll = useCallback(() => {
        const doc = document.documentElement;
        const newScrollTop = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
        if (newScrollTop > 1000) return;
        setScrollTop(newScrollTop)
    }, [setScrollTop]);

    const getDontaionData = () => {
        dispatch(get<IDonationData>("donation/summary", (data) => {
            setDonationData(data.data);
        }));
    };

    useEffect(() => {
        if (!isMobile) {
            window.addEventListener("scroll", handleScroll);
        }
        if (window.location.hash === "#application") {
            scrollToTaskTypes();
        }

        getDontaionData();
        return () => {
            window.removeEventListener("scroll", handleScroll);
        }
    }, []);


    const donationProgress = !!donationData ? Math.floor(donationData.collected / (donationData.min + donationData.extra) * 100) : 0;

    return (
        <StyledHero>
            <Background
                style={{
                    backgroundImage: `url(${dev
                        ? `'/images/main-hero.${webp ? "webp" : "jpg"}'`
                        : amazonHost + `landing/main-hero.${webp ? "webp" : "jpg"}`
                        })`,
                    transform: `translate3d(0, ${scrollTop / 3}px, 0)`,
                }}
            ></Background>
            <HeroContent locale={locale}>
                <h1>
                    <FormattedHTMLMessage {...messages.h1} />
                </h1>
                <h2>
                    <FormattedMessage {...messages.h2} />
                </h2>
                <ButtonWrapper>
                    <Link to={"/" + (!user ? routing.signup : user.loggedIn ? (user.isStudent ? routing.dashboardStudent : routing.dashboard) : routing.signup)}>
                        <Button className={cn("button--pretty", "button")}>
                            <FormattedMessage {...messages.start} />
                        </Button>
                    </Link>
                </ButtonWrapper>
                <div>
                    <LaunchContainer className={!!donationData && donationData.year >= donationData.minYear && "Visible"} onClick={handleOpenDonation}>
                        <Progress style={{ width: `${Math.min(100, donationProgress)}%` }} />
                        <ProgressTitle>
                            <FormattedMessage {...messages.donationStripeTitle} />
                        </ProgressTitle>
                        <Percent>{donationProgress}%</Percent>
                        <YearIcon>{donationData?.year}</YearIcon>
                    </LaunchContainer>
                </div>
                <RecentPlans />
                <MorePlans>
                    <Link
                        className="link"
                        to={"/" + routing.browse}
                    >
                        <FormattedMessage {...messages.morePlans} />
                        <Icon i="chevron-right" />
                    </Link>
                </MorePlans>
                <ToMemory href="/memory">
                    <FormattedMessage {...messages.toMemory} /> <Icon i="arrowback" />
                </ToMemory>
                {locale === 'hu' && (
                    <ToChoir href="/choir" >
                        <FormattedMessage {...messages.toChoir} /> <Icon i="arrowback" />
                    </ToChoir>
                )}
            </HeroContent>
            {donationOpen && <DonationPopup onClose={handleCloseDonation} donationData={donationData} donationProgress={donationProgress} />}
        </StyledHero >
    );
}

export default Hero;
